import axios from 'axios';
import constants from '../../config/constants';

export const GET_ALL_EMPLOYEES = 'GET_ALL_EMPLOYEES';
export const GET_SCHOOL_EMPLOYEES = 'GET_SCHOOL_EMPLOYEES';
export const GET_EMPLOYEE = 'GET_EMPLOYEE';
export const GET_ALL_EMP_ASSIGN_SUBJECTS = 'GET_ALL_EMP_ASSIGN_SUBJECTS';
export const GET_EMP_ASSIGN_SUBJECTS = 'GET_EMP_ASSIGN_SUBJECTS';
// Leave
export const GET_EMPLOYEE_LEAVES = 'GET_EMPLOYEE_LEAVES';

export const UPDATE_EMPLOYEE_ID = 'UPDATE_EMPLOYEE_ID';
export const UPDATE_COURSE_ID = 'UPDATE_COURSE_ID';

// Common
export const updateEmployeeId = employeeId => ({
  type: UPDATE_EMPLOYEE_ID,
  employeeId,
});

export const updateCourseId = courseId => ({
  type: UPDATE_COURSE_ID,
  courseId,
});

//= ========== Reducer call functions begin ===========//
export const getAllEmployees = employeesData => ({
  type: GET_ALL_EMPLOYEES,
  employeesData,
});

export const getSchoolEmployees = employees => ({
  type: GET_SCHOOL_EMPLOYEES,
  employees,
});

export const getEmployee = employee => ({
  type: GET_EMPLOYEE,
  employee,
});

export const getAllEmpAssignSubjects = empAssignSubjects => ({
  type: GET_ALL_EMP_ASSIGN_SUBJECTS,
  empAssignSubjects,
});

export const getEmpAssignSubject = empAssignSubject => ({
  type: GET_EMP_ASSIGN_SUBJECTS,
  empAssignSubject,
});

// Leave
export const getEmployeeLeaves = empLeaves => ({
  type: GET_EMPLOYEE_LEAVES,
  empLeaves,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchAllEmployeesService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-employees-by-page/${data.schoolId}${constants.makeParams(
        data.pageParams
      )}`,
      constants.setHeader(data.token)
    );
    dispatch(getAllEmployees(res.data));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolEmployeesApi = async data => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-employees/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolEmployeesService = data => async dispatch => {
  try {
    const employees = await fetchSchoolEmployeesApi(data);
    dispatch(getSchoolEmployees(employees));
    return employees;
  } catch (err) {
    console.error(err.response);
  }
};

export const saveEmployeeService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-employee`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchEmployeeService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/employee/get-employee/${data.employeeId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getEmployee(res.data));
};

export const updateEmployeeService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/update-employee/${data.employeeId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteEmployeeService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-employee/${data.employeeId}`,
    constants.setHeader(data.token)
  );
};

// Employee subject assign section ///
export const fetchAllEmpAssignSubjectsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/school-assigned-teacher-subject/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllEmpAssignSubjects(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const saveEmpAssignSubjectService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/assign-teacher-subject`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchEmpAssignSubjectService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/assigned-teacher-subject/${data.employeeId}/${data.batchId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getEmpAssignSubject(res.data));
};

// Same lookup as fetchEmpAssignSubjectService, without the dispatch - used by
// AssignTeacherSubjectModal (Subjects page) to find the teacherSubjectId for one
// subject before reassigning it, without clobbering the Employee page's own
// empAssignSubject store state.
export const fetchEmpAssignSubjectApi = data => {
  return axios.get(
    `${constants.API_BASE_URL}/api/admin/assigned-teacher-subject/${data.employeeId}/${data.batchId}`,
    constants.setHeader(data.token)
  );
};

export const updateEmpAssignSubjectService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-assign-teacher-subject`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteEmpAssignSubjectService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/remove-assigne-subject/${data.teacherSubjectId}`,
    constants.setHeader(data.token)
  );
};

// Leaves
export const fetchEmployeeLeaveService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/leave/${data.employeeId}${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    return dispatch(getEmployeeLeaves(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const fetchEmployeeLeavesByAdminService = data => async dispatch => {
  const url = `${constants.API_BASE_URL}/api/employee/leaves/status/${data.schoolId}/${data.employeeId}/${data.selectedStatusType}`;
  try {
    const res = await axios.get(url, constants.setHeader(data.token));
    return dispatch(getEmployeeLeaves(res.data));
  } catch (err) {
    console.error('err', err);
  }
};

export const applyEmpLeaveService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/employee/apply/leave`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const approveLeaveService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/approve/leave/${data.studentId}/${data.leaveId}`,
    { status: 'APPROVED' },
    constants.setHeader(data.token)
  );
};

export const cancelLeaveService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/approve/leave/${data.studentId}/${data.leaveId}`,
    { status: 'REJECTED' },
    constants.setHeader(data.token)
  );
};
//= ========== User routing end ===========//
